webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(61);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _fastclick = __webpack_require__(135);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	var _MainView = __webpack_require__(191);
	
	var _MainView2 = _interopRequireDefault(_MainView);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	  new _vue2.default({
	    el: 'body',
	    components: { MainView: _MainView2.default }
	  });
	
	  _fastclick2.default.attach(document.body);
	
	  $('body').on('touchmove', false);
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _brushes = __webpack_require__(62);
	
	var _brushes2 = _interopRequireDefault(_brushes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	
	  TOOLS: ['select', 'pencil', 'line', 'spray', 'rect', 'roundrect', 'circle', 'oval', 'blob', 'move', 'eraser', 'brush', 'bucket', 'rectfill', 'roundrectfill', 'circlefill', 'ovalfill', 'blobfill'],
	
	  ENABLED_TOOLS: ['pencil', 'line', 'rect', 'circle', 'eraser', 'spray', 'brush', 'rectfill', 'circlefill', 'oval', 'ovalfill', 'move', 'bucket', 'blob', 'blobfill', 'triangle', 'trianglefill', 'roundrect', 'roundrectfill', 'select'],
	
	  AVAILABLE_FONTS: [{ val: 'monospaced', label: 'Courier' }, { val: 'sans-serif', label: 'Helvetica' }, { val: 'serif', label: 'Times' }],
	
	  AVAILABLE_BRUSHES: _brushes2.default.BRUSHES,
	
	  AVAILABLE_STYLES: [{ val: 'normal', label: 'Plain' }, { val: 'bold', label: 'Bold' }, { val: 'italic', label: 'Italic' }, { val: 'underline', label: 'Underline' }, { val: 'outline', label: 'Outline' }, { val: 'strikeout', label: 'Strikeout' }],
	
	  AVAILABLE_FONT_SIZES: [[6, 8, 10, 12, 15, 16, 18, 20, 24, 30], [32, 36, 37, 40, 42, 45, 48, 50, 56, 60], [64, 70, 72, 74, 75, 80, 84]],
	
	  AVAILABLE_COLORS: ['#e3008c', '#a80000', '#e81123', '#d83b01', '#ff8c00', '#fff100', '#b4009e', '#5c005c', '#b4a0ff', '#5c2d91', '#32145a', '#00bcf2', '#bad80a', '#004b50', '#00b294', '#002050', '#00188f', '#0078d7', '#107c10', '#004b1c', '#ffffff', '#d2d2d2', '#737373', '#000000'],
	
	  title: '(untitled)',
	  font: 'serif',
	  fontSize: 16,
	  style: 'normal',
	  tool: 'brush',
	  color: '#000000',
	  lineWidth: 1,
	  selectedBrush: _brushes2.default.BRUSHES[1],
	  eraserBrush: _brushes2.default.BRUSHES[6],
	  colorDisplay: true,
	  alignment: 'left',
	  transparent: false,
	  grid: 0,
	  paletteView: null,
	  backgroundColor: '#ffffff',
	  undoEnabled: false,
	  currentView: 'boot-screen',
	  readyForSave: false,
	
	  isToolEnabled: function isToolEnabled(t) {
	    return this.ENABLED_TOOLS.indexOf(t) != -1;
	  },
	  setTool: function setTool(t) {
	    if (this.isToolEnabled(t)) {
	      this.tool = t;
	      window.paint.onToolChange(t);
	    }
	  },
	  setColor: function setColor(c) {
	    this.color = c;
	    this.closePalette();
	  },
	  setFont: function setFont(f) {
	    this.font = f;
	  },
	  setStyle: function setStyle(s) {
	    this.style = s;
	  },
	  setAlignment: function setAlignment(a) {
	    this.alignment = a;
	  },
	  setFontSize: function setFontSize(n) {
	    this.fontSize = parseInt(n, 10);
	  },
	  setLineWidth: function setLineWidth(n) {
	    this.lineWidth = Number(n);
	    this.closePalette();
	  },
	  setBrush: function setBrush(n) {
	    this.selectedBrush = _brushes2.default.BRUSHES[parseInt(n, 10)] || null;
	    this.closePalette();
	  },
	  getSelectedBrushStamp: function getSelectedBrushStamp() {
	    return _brushes2.default.getStampImage(this.selectedBrush);
	  },
	  getEraserBrushStamp: function getEraserBrushStamp() {
	    return _brushes2.default.getStampImage(this.eraserBrush);
	  },
	  setGrid: function setGrid(n) {
	    this.grid = parseInt(n, 10);
	  },
	  toggleColorDisplay: function toggleColorDisplay() {
	    this.colorDisplay = !this.colorDisplay;
	  },
	  setTransparent: function setTransparent(isTransparent) {
	    this.transparent = Boolean(isTransparent);
	  },
	  showPalette: function showPalette(name) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.paletteView = name;
	    }, 125);
	  },
	  closePalette: function closePalette() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.paletteView = null;
	    }, 100);
	  },
	  toggleZoom: function toggleZoom() {
	    $('body').toggleClass('zoom-zoom');
	  }
	};
	
	exports.default = state;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(61);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  ENV: ("production"),
	  VERSION: ("1.0.2"),
	
	  devMode: ("production") == 'development',
	
	  shareUrl: "http://microsoft.com/",
	  shareTitle: "Testing. Check it out...",
	
	  overlayArtwork: '/static/images/ninjacat-emulator-010.8bit.logo2.png'
	};
	
	exports.default = config;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterImage(context) {
	
	  var imageData = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
	  var data = imageData.data;
	
	  for (var i = 0; i < data.length; i += 4) {
	
	    var a = data[i + 3] / 255;
	
	    if (a < .35) {
	      data[i + 3] = 0;
	      continue;
	    }
	
	    data[i + 3] = 255;
	
	    if (!_state2.default.colorDisplay) {
	      var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
	
	      brightness = Math.round(Math.pow(brightness / 255, 3)) * 255;
	
	      data[i] = brightness;
	
	      data[i + 1] = brightness;
	
	      data[i + 2] = brightness;
	    }
	  }
	
	  context.putImageData(imageData, 0, 0);
	}
	
	exports.default = filterImage;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var cache = {};
	
	function getImage(src) {
	  cache[src] = cache[src] || promiseImage(src);
	  return cache[src];
	}
	
	function promiseImage(src) {
	  var defer = $.Deferred();
	  var img = loadImage(src, function () {
	    defer.resolve(img);
	  });
	  return defer.promise();
	}
	
	function loadImage(src, onLoad) {
	  var img = new Image();
	  img.src = src;
	  $(img).on('load', function () {
	    try {
	      if (onLoad) onLoad(img);
	    } catch (e) {}
	  });
	  return img;
	}
	
	exports.default = getImage;

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(119)
	__vue_script__ = __webpack_require__(71)
	__vue_template__ = __webpack_require__(173)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(76)
	__vue_template__ = __webpack_require__(177)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(124)
	__vue_script__ = __webpack_require__(79)
	__vue_template__ = __webpack_require__(179)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(125)
	__vue_script__ = __webpack_require__(80)
	__vue_template__ = __webpack_require__(180)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(128)
	__vue_script__ = __webpack_require__(81)
	__vue_template__ = __webpack_require__(182)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(130)
	__vue_script__ = __webpack_require__(82)
	__vue_template__ = __webpack_require__(184)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(134)
	__vue_script__ = __webpack_require__(83)
	__vue_template__ = __webpack_require__(188)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(131)
	__vue_script__ = __webpack_require__(84)
	__vue_template__ = __webpack_require__(185)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(132)
	__vue_script__ = __webpack_require__(85)
	__vue_template__ = __webpack_require__(186)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _imageLoader = __webpack_require__(34);
	
	var _imageLoader2 = _interopRequireDefault(_imageLoader);
	
	var _brushes = __webpack_require__(165);
	
	var _brushes2 = _interopRequireDefault(_brushes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var brushImg;
	var brushCanvas = document.createElement('canvas');
	var brushCtx = brushCanvas.getContext('2d');
	
	(0, _imageLoader2.default)(_brushes2.default).then(function (img) {
	  brushImg = img;
	});
	
	var lastBrush = null;
	
	var brushes = {
	
	  BRUSHES: [],
	
	  getStampImage: function getStampImage(b) {
	
	    if (brushImg && lastBrush != b) {
	
	      var size = 20;
	
	      brushCanvas.width = size;
	      brushCanvas.height = size;
	
	      brushCtx.drawImage(brushImg, -b.bx, -b.by, size, size, 0, 0, size, size);
	    }
	
	    lastBrush = b;
	
	    return brushCanvas;
	  }
	};
	
	var cols = 6;
	var rows = 4;
	
	for (var n = 0; n < cols * rows; n++) {
	
	  var b = {
	    idx: n,
	    row: Math.floor(n / cols),
	    col: Math.round(n % cols)
	  };
	
	  b.bx = -10 - b.col * 40;
	  b.by = 0 - b.row * 20;
	
	  b.backgroundPosition = b.bx + 'px ' + b.by + 'px';
	
	  brushes.BRUSHES.push(b);
	}
	
	exports.default = brushes;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(163);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _filterImage = __webpack_require__(33);
	
	var _filterImage2 = _interopRequireDefault(_filterImage);
	
	var _imageLoader = __webpack_require__(34);
	
	var _imageLoader2 = _interopRequireDefault(_imageLoader);
	
	var _canvasUtil = __webpack_require__(64);
	
	var _canvasUtil2 = _interopRequireDefault(_canvasUtil);
	
	var _download2 = __webpack_require__(65);
	
	var _download3 = _interopRequireDefault(_download2);
	
	var _floodFill = __webpack_require__(66);
	
	var _floodFill2 = _interopRequireDefault(_floodFill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sprayImageSrc = __webpack_require__(169);
	var hashtagImageSrc = __webpack_require__(167);
	
	var canvasPaint = function canvasPaint(el, state) {
	  var canvas = el.querySelector('#paintcanvas');
	  canvas.setAttribute('touch-action', 'none');
	  var ctx = canvas.getContext('2d');
	  var tmp_canvas;
	  var tmp_ctx;
	  var hint_canvas;
	  var hint_ctx;
	  var overlay_canvas;
	  var overlay_ctx;
	  var select_canvas;
	  var select_ctx;
	  var stamp_canvas;
	  var stamp_ctx;
	  var empty_canv;
	  var sprayIntervalID;
	  var round_coords = true;
	  var grid_sizes = [0, 4, 8, 16];
	  var draggables;
	
	  var undo_arr, undo_count;
	
	  var pointers = [];
	
	  var stampImage, pencilImage, hashTagImage;
	
	  var tools = {
	    pencil: onPaintStamp,
	    brush: onPaintStamp,
	    circle: onPaintCircle,
	    circlefill: onPaintCircle,
	    line: onPaintLine,
	    rect: onPaintRect,
	    rectfill: onPaintRect,
	    roundrect: onPaintRoundRect,
	    roundrectfill: onPaintRoundRect,
	    oval: onPaintEllipse,
	    ovalfill: onPaintEllipse,
	    eraser: onPaintStamp,
	
	    spray: onSpray,
	    move: onMove,
	    bucket: noop,
	    triangle: noop,
	    triangleFill: noop,
	    select: onDrawSelect
	  };
	
	  initCanvii();
	  initStamps();
	  reset();
	  initListeners();
	
	  function initCanvii() {
	    tmp_canvas = document.createElement('canvas');
	    hint_canvas = document.createElement('canvas');
	    select_canvas = document.createElement('canvas');
	    overlay_canvas = document.createElement('canvas');
	    tmp_canvas.setAttribute('touch-action', 'none');
	    tmp_ctx = tmp_canvas.getContext('2d');
	    hint_ctx = hint_canvas.getContext('2d');
	    select_ctx = select_canvas.getContext('2d');
	    overlay_ctx = overlay_canvas.getContext('2d');
	    select_canvas.id = 'select_canvas';
	    select_canvas.setAttribute('touch-action', 'none');
	    tmp_canvas.id = 'tmp_canvas';
	    overlay_canvas.width = hint_canvas.width = tmp_canvas.width = canvas.width;
	    overlay_canvas.height = hint_canvas.height = tmp_canvas.height = canvas.height;
	    overlay_canvas.id = 'overlay_canvas';
	    hint_canvas.id = 'hint_canvas';
	
	    canvas.parentNode.appendChild(tmp_canvas);
	    canvas.parentNode.appendChild(hint_canvas);
	    canvas.parentNode.appendChild(select_canvas);
	    canvas.parentNode.appendChild(overlay_canvas);
	
	    stamp_canvas = document.createElement('canvas');
	    stamp_canvas.width = 20;
	    stamp_canvas.height = 20;
	    stamp_ctx = stamp_canvas.getContext('2d');
	
	    ctx.imageSmoothingEnabled = false;
	    tmp_ctx.imageSmoothingEnabled = false;
	
	    ctx.fillStyle = state.backgroundColor;
	    ctx.fillRect(0, 0, canvas.width, canvas.height);
	  }
	
	  function initStamps() {
	    pencilImage = document.createElement('canvas');
	    pencilImage.width = 1;
	    pencilImage.height = 1;
	    pencilImage.getContext('2d').fillRect(0, 0, 1, 1);
	
	    (0, _imageLoader2.default)(sprayImageSrc).then(function (img) {
	      stampImage = document.createElement('canvas');
	      stampImage.width = stampImage.height = 20;
	      stampImage.getContext('2d').drawImage(img, 0, 0, 20, 20);
	    });
	
	    (0, _imageLoader2.default)(hashtagImageSrc).then(function (img) {
	      hashTagImage = img;
	    });
	  }
	
	  function initListeners() {
	    tmp_canvas.addEventListener('pointerdown', startDrawing, false);
	    document.addEventListener('pointercancel', stopDrawing);
	    select_canvas.addEventListener('pointerdown', startDraggingSelection, false);
	  }
	
	  function noop() {}
	
	  function reset() {
	    var fill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    state.undoEnabled = false;
	    state.readyForSave = false;
	
	    stopDrawing();
	    ctx.save();
	    if (fill) {
	      ctx.fillStyle = state.backgroundColor;
	      ctx.fillRect(0, 0, canvas.width, canvas.height);
	    }
	    overlay_ctx.clearRect(0, 0, canvas.width, canvas.height);
	    ctx.restore();
	    undo_arr = [];
	    pointers = [];
	    undo_count = 0;
	    empty_canv = canvas.toDataURL();
	    undo_arr.push(empty_canv);
	
	    var container = $(canvas).parent().parent();
	    container[0].scrollLeft = 0;
	    container[0].scrollTop = 29;
	    $(select_canvas).hide();
	  }
	
	  function startDrawing(e) {
	    if (state.drawing) return;
	
	    state.drawing = true;
	    state.readyForSave = true;
	
	    tmp_canvas.addEventListener('pointermove', onPaint, false);
	    document.addEventListener('pointerup', stopDrawing, false);
	
	    var pointer = pointers[e.pointerId] = {
	      current: { x: 0, y: 0 },
	      start: { x: 0, y: 0 }
	    };
	
	    updatePointer(e);
	
	    pointer.start.x = pointer.current.x;
	    pointer.start.y = pointer.current.y;
	    pointer.path = [_lodash2.default.clone(pointer.current)];
	
	    clearInterval(sprayIntervalID);
	    if (state.tool == 'spray') {}
	
	    onPaint(e);
	  }
	
	  function stopDrawing(e) {
	
	    if (e && e.target == tmp_canvas) {
	      completePainting(updatePointer(e));
	    } else {
	      cancelPainting(updatePointer(e));
	    }
	
	    if (e && e.pointerId && pointers[e.pointerId]) {
	      delete pointers[e.pointerId];
	    }
	
	    if (!state.drawing) return;
	
	    state.drawing = false;
	
	    tmp_canvas.removeEventListener('pointermove', onPaint, false);
	    document.removeEventListener('pointerup', stopDrawing, false);
	
	    if (state.tool != 'select') {
	      pushUndoState();
	    }
	  }
	
	  var previous_ctx, redo_ctx;
	
	  function pushUndoState() {
	    previous_ctx = previous_ctx || document.createElement('canvas').getContext('2d');
	    redo_ctx = redo_ctx || document.createElement('canvas').getContext('2d');
	    redo_ctx.canvas.width = previous_ctx.canvas.width = canvas.width;
	    redo_ctx.canvas.height = previous_ctx.canvas.height = canvas.height;
	
	    previous_ctx.fillStyle = state.backgroundColor;
	    previous_ctx.fillRect(0, 0, canvas.width, canvas.height);
	    previous_ctx.drawImage(canvas, 0, 0);
	
	    ctx.drawImage(tmp_canvas, 0, 0);
	
	    redo_ctx.fillStyle = state.backgroundColor;
	    redo_ctx.fillRect(0, 0, canvas.width, canvas.height);
	    redo_ctx.drawImage(canvas, 0, 0);
	
	    state.undoEnabled = true;
	
	    (0, _filterImage2.default)(ctx);
	
	    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);
	  }
	
	  function updatePointer(e) {
	
	    if (e) {
	
	      var pointer = pointers[e.pointerId];
	
	      if (!pointer) {
	        return null;
	      }
	
	      var mouse = {};
	      var offset = $(e.target).offset();
	      var rect = e.target.getBoundingClientRect();
	
	      pointer.last = pointer.current || mouse;
	
	      mouse.scale = rect.width / canvas.width;
	
	      mouse.x = (e.pageX - offset.left) / mouse.scale;
	      mouse.y = (e.pageY - offset.top) / mouse.scale;
	
	      if (state.grid && toolUsesGrid(state.tool)) {
	        var gridSize = grid_sizes[state.grid];
	        mouse.x = Math.round(mouse.x / gridSize) * gridSize;
	        mouse.y = Math.round(mouse.y / gridSize) * gridSize;
	      }
	
	      if (round_coords) {
	        mouse.x = mouse.x >> 0;
	        mouse.y = mouse.y >> 0;
	      }
	
	      pointer.current = mouse;
	
	      pointer.distance = distance(pointer.last, pointer.current);
	
	      if (pointer.start) {
	        pointer.distanceFromStart = distance(pointer.start, pointer.current);
	      }
	
	      return pointer;
	    } else {
	      return null;
	    }
	  }
	
	  function toolUsesGrid(tool) {
	    switch (tool) {
	      case 'move':
	      case 'erase':
	        return false;
	      default:
	        return true;
	    }
	  }
	
	  function onPaint(e) {
	
	    var paint_func = tools[state.tool] || tools.brush;
	    var pointer = updatePointer(e);
	
	    if (pointer) {
	
	      tmp_ctx.strokeStyle = state.color;
	      tmp_ctx.fillStyle = state.color;
	      tmp_ctx.lineWidth = state.tool == 'pencil' ? 1.0 : state.lineWidth;
	      tmp_ctx.lineJoin = 'round';
	      tmp_ctx.lineCap = 'round';
	
	      paint_func(pointer);
	
	      (0, _filterImage2.default)(tmp_ctx);
	    }
	  }
	
	  function completePainting(pointer) {
	    switch (state.tool) {
	      case 'blob':
	      case 'blobfill':
	        var stamp = pencilImage;
	        drawLineWithStamp(tmp_ctx, pencilImage, pointer.start, pointer.current, 1);
	        colorizeActiveDrawing();
	
	
	        var do_fill = state.tool.indexOf('fill') != -1;
	        var pencil_stroke = state.lineWidth == 1 && !do_fill;
	
	        var ctx = tmp_ctx;
	
	        if (!pencil_stroke) {
	          ctx.clearRect(0, 0, canvas.width, canvas.height);
	        }
	        ctx.save();
	        ctx.beginPath();
	        ctx.moveTo(pointer.start.x, pointer.start.y);
	        _lodash2.default.each(pointer.path, function (p) {
	          ctx.lineTo(p.x, p.y);
	        });
	        ctx.lineTo(pointer.start.x, pointer.start.y);
	
	        if (state.tool.indexOf('fill') != -1) {
	          ctx.fill();
	        }
	
	        if (!pencil_stroke) {
	          ctx.stroke();
	        }
	        ctx.restore();
	        break;
	
	      case 'select':
	        initSelection(pointer);
	        break;
	
	      case 'bucket':
	        onBucketFill(pointer);
	        break;
	    }
	    (0, _filterImage2.default)(tmp_ctx);
	  }
	
	  function onDrawSelect(pointer) {
	    stopDraggingSelection();
	
	    $(select_canvas).hide();
	
	    var mouse = pointer.current;
	    var start_mouse = pointer.start;
	
	    hint_ctx.clearRect(0, 0, hint_canvas.width, hint_canvas.height);
	
	    hint_ctx.lineJoin = 'miter';
	    hint_ctx.setLineDash([2, 4]);
	
	    var x = Math.min(mouse.x, start_mouse.x) + 0.5;
	    var y = Math.min(mouse.y, start_mouse.y) + 0.5;
	    var width = Math.abs(mouse.x - start_mouse.x);
	    var height = Math.abs(mouse.y - start_mouse.y);
	
	    hint_ctx.strokeWidth = .5;
	    hint_ctx.strokeRect(x, y, width, height);
	  }
	
	  var dragStart = { x: 0, y: 0 };
	  var dragLoc = null;
	  var selectLoc = { x: 0, y: 0 };
	  var dragOffset = { x: 0, y: 0 };
	  var dragging = false;
	  var hasSelection = false;
	  var selectionMoved = false;
	
	  function initSelection(pointer) {
	
	    var mouse = pointer.current;
	    var start = pointer.start;
	
	    var x = Math.min(mouse.x, start.x) >> 0;
	    var y = Math.min(mouse.y, start.y) >> 0;
	    var width = Math.abs(mouse.x - start.x) >> 0;
	    var height = Math.abs(mouse.y - start.y) >> 0;
	
	    hint_ctx.clearRect(0, 0, hint_canvas.width, hint_canvas.height);
	
	    if (width < 16 && height < 16) {
	      clearSelection();
	      return;
	    }
	
	    select_canvas.width = width;
	    select_canvas.height = height;
	    select_ctx.fillStyle = state.backgroundColor;
	    select_ctx.fillRect(0, 0, width, height);
	    select_ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);
	
	    if (!hasSelection) {
	      console.log('no selection yet, making sure tmp_ctx has latest canvas');
	      tmp_ctx.fillStyle = '#ff0000';
	      tmp_ctx.fillRect(0, 0, canvas.width, canvas.height);
	      tmp_ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);
	    }
	
	    $(select_canvas).show();
	
	    selectLoc.x = x;
	    selectLoc.y = y;
	
	    TweenLite.set(select_canvas, {
	      x: x,
	      y: y
	    });
	
	    tmp_ctx.fillStyle = state.backgroundColor;
	    tmp_ctx.fillRect(selectLoc.x, selectLoc.y, select_canvas.width, select_canvas.height);
	
	    hasSelection = true;
	    selectionMoved = false;
	  }
	
	  function clearSelection() {
	    if (hasSelection) {
	      applySelection();
	    }
	    hasSelection = false;
	    selectionMoved = false;
	    dragging = false;
	    stopDraggingSelection();
	    $(select_canvas).hide();
	  }
	
	  function applySelection() {
	    tmp_ctx.drawImage(select_canvas, selectLoc.x >> 0, selectLoc.y >> 0, select_canvas.width, select_canvas.height);
	
	    pushUndoState();
	  }
	
	  function startDraggingSelection(e) {
	
	    var offset = $(canvas).offset();
	    var rect = canvas.getBoundingClientRect();
	
	    dragLoc = null;
	
	    dragStart.scale = rect.width / canvas.width;
	    dragStart.x = (e.pageX - offset.left) / dragStart.scale;
	    dragStart.y = (e.pageY - offset.top) / dragStart.scale;
	
	    dragOffset.x = dragStart.x - $(select_canvas).offset().left / dragStart.scale;
	    dragOffset.y = dragStart.y - $(select_canvas).offset().top / dragStart.scale;
	
	    console.log('drag start', dragStart, dragOffset);
	
	    $(canvas).parent().addClass('dragging');
	
	    tmp_canvas.addEventListener('pointermove', onDragSelection, false);
	    document.addEventListener('pointerup', stopDraggingSelection, false);
	  }
	
	  function onDragSelection(e) {
	
	    selectionMoved = true;
	    dragging = true;
	
	    var mouse = {};
	    var offset = $(canvas).offset();
	    var rect = canvas.getBoundingClientRect();
	
	    mouse.scale = rect.width / canvas.width;
	    mouse.x = (e.pageX - offset.left) / mouse.scale;
	    mouse.y = (e.pageY - offset.top) / mouse.scale;
	
	    var prev = dragLoc || dragStart;
	
	    selectLoc.x += mouse.x - prev.x;
	    selectLoc.y += mouse.y - prev.y;
	
	    TweenLite.set(select_canvas, {
	      x: selectLoc.x,
	      y: selectLoc.y,
	      z: -1 });
	
	    dragLoc = mouse;
	  }
	
	  function stopDraggingSelection(e) {
	
	    if (e && dragging) {}
	
	    dragging = false;
	    $(canvas).parent().removeClass('dragging');
	
	    tmp_canvas.removeEventListener('pointermove', onDragSelection, false);
	    document.removeEventListener('pointerup', stopDraggingSelection, false);
	  }
	
	  function cancelPainting(pointer) {
	    switch (state.tool) {
	      case 'blob':
	      case 'blobfill':
	        tmp_ctx.clearRect(0, 0, canvas.width, canvas.height);
	        break;
	    }
	  }
	
	  function onPaintCircle(pointer) {
	
	    var mouse = pointer.current;
	    var start_mouse = pointer.start;
	
	    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);
	
	    var x = (mouse.x + start_mouse.x) / 2;
	    var y = (mouse.y + start_mouse.y) / 2;
	
	    var radius = Math.max(Math.abs(mouse.x - start_mouse.x), Math.abs(mouse.y - start_mouse.y)) / 2;
	
	    tmp_ctx.beginPath();
	    tmp_ctx.arc((x >> 0) + .5, (y >> 0) + .5, radius >> 0, 0, Math.PI * 2, false);
	    tmp_ctx.stroke();
	    if (state.tool.indexOf('fill') != -1) {
	      tmp_ctx.fill();
	    }
	    tmp_ctx.closePath();
	  }
	
	  function onPaintLine(pointer) {
	
	    var mouse = pointer.current;
	    var start_mouse = pointer.start;
	
	    tmp_ctx.lineCap = 'square';
	
	    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);
	
	    tmp_ctx.beginPath();
	    tmp_ctx.moveTo(start_mouse.x, start_mouse.y);
	    tmp_ctx.lineTo(mouse.x, mouse.y);
	    tmp_ctx.stroke();
	    tmp_ctx.closePath();
	  }
	
	  function onPaintRect(pointer) {
	
	    var mouse = pointer.current;
	    var start_mouse = pointer.start;
	
	    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);
	
	    tmp_ctx.lineJoin = 'miter';
	
	    var x = Math.min(mouse.x, start_mouse.x) + 0.5;
	    var y = Math.min(mouse.y, start_mouse.y) + 0.5;
	    var width = Math.abs(mouse.x - start_mouse.x);
	    var height = Math.abs(mouse.y - start_mouse.y);
	    if (state.tool.indexOf('fill') != -1) {
	      tmp_ctx.fillRect(x, y, width, height);
	    }
	    tmp_ctx.strokeRect(x, y, width, height);
	  }
	
	  function onPaintRoundRect(pointer) {
	    var mouse = pointer.current;
	    var start_mouse = pointer.start;
	
	    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);
	
	    var x = Math.min(mouse.x, start_mouse.x) + 0.5;
	    var y = Math.min(mouse.y, start_mouse.y) + 0.5;
	    var width = Math.abs(mouse.x - start_mouse.x);
	    var height = Math.abs(mouse.y - start_mouse.y);
	    var corner_radius = Math.min(9, width / 2, height / 2);
	    _canvasUtil2.default.drawRoundRect(tmp_ctx, x, y, width, height, corner_radius, state.tool.indexOf('fill') != -1, true);
	  }
	
	  function onPaintEllipse(pointer) {
	
	    var mouse = pointer.current;
	    var start_mouse = pointer.start;
	
	    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);
	
	    var x = Math.min(mouse.x, start_mouse.x);
	    var y = Math.min(mouse.y, start_mouse.y);
	
	    var w = Math.abs(mouse.x - start_mouse.x);
	    var h = Math.abs(mouse.y - start_mouse.y);
	
	    var kappa = .5522848,
	        ox = w / 2 * kappa,
	        oy = h / 2 * kappa,
	        xe = x + w,
	        ye = y + h,
	        xm = x + w / 2,
	        ym = y + h / 2;
	
	    tmp_ctx.beginPath();
	    tmp_ctx.moveTo(x, ym);
	    tmp_ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	    tmp_ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	    tmp_ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	    tmp_ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	    tmp_ctx.closePath();
	    tmp_ctx.stroke();
	    if (state.tool.indexOf('fill') != -1) {
	      tmp_ctx.fill();
	    }
	  }
	
	  function onMove(pointer) {
	    var container = $(canvas).parent().parent();
	    container[0].scrollLeft += pointer.start.x - pointer.current.x;
	    container[0].scrollTop += pointer.start.y - pointer.current.y;
	  }
	
	  function onSpray(pointer) {
	    paintWithStamp(tmp_ctx, stampImage, pointer.current, 20);
	    colorizeActiveDrawing();
	  }
	
	  function onPaintStamp(pointer) {
	
	    pointer.path.push(pointer.current);
	
	    var stamp = void 0,
	        size = 20;
	
	    switch (state.tool) {
	      case 'pencil':
	      case 'blob':
	      case 'blobfill':
	        stamp = pencilImage;
	        size = 1;
	        break;
	
	      case 'eraser':
	        stamp = state.getEraserBrushStamp();
	        tmp_ctx.fillStyle = state.backgroundColor;
	        break;
	      default:
	        stamp = state.getSelectedBrushStamp();
	    }
	
	    paintWithStamp(tmp_ctx, stamp, pointer.current, size);
	    drawLineWithStamp(tmp_ctx, stamp, pointer.last, pointer.current, size);
	    colorizeActiveDrawing();
	  }
	
	  function pointAlongLine(start, end, t) {
	    return {
	      x: start.x + (end.x - start.x) * t,
	      y: start.y + (end.y - start.y) * t
	    };
	  }
	
	  function drawLineWithStamp(ctx, stamp, start, end) {
	    var size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;
	
	    var inc = 1;
	    var d = distance(start, end);
	    for (var i = 0; i < d; i += inc) {
	      var p = pointAlongLine(start, end, i / d);
	      paintWithStamp(ctx, stamp, p, size);
	    }
	  }
	
	  function distance(start, end) {
	    var dx = end.x - start.x;
	    var dy = end.y - start.y;
	    return Math.sqrt(dx * dx + dy * dy);
	  }
	
	  function paintWithStamp(ctx, img, loc) {
	    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
	
	    ctx.save();
	    ctx.translate(loc.x - size / 2, loc.y - size / 2);
	    ctx.drawImage(img, 0, 0, size, size);
	    ctx.restore();
	  }
	
	  function colorizeActiveDrawing() {
	    tmp_ctx.globalCompositeOperation = 'source-in';
	    tmp_ctx.fillRect(0, 0, canvas.width, canvas.height);
	    tmp_ctx.globalCompositeOperation = 'source-over';
	  }
	
	  function onBucketFill(pointer) {
	    tmp_ctx.save();
	    tmp_ctx.fillStyle = state.backgroundColor;
	    tmp_ctx.fillRect(0, 0, canvas.width, canvas.height);
	    tmp_ctx.restore();
	    tmp_ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);
	
	    var image = tmp_ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var data = image.data;
	
	    var tolerance = 0;
	    (0, _floodFill2.default)(tmp_ctx, state.color, Math.floor(pointer.current.x), Math.floor(pointer.current.y), tolerance, 0, 0, canvas.width, canvas.height);
	  }
	
	  function drawUndo(count) {
	    var number = undo_arr.length;
	    var img_data = undo_arr[number - (count + 1)];
	    var undo_img = new Image();
	    undo_img.src = img_data.toString();
	    ctx.clearRect(0, 0, canvas.width, canvas.height);
	    ctx.drawImage(undo_img, 0, 0);
	  }
	
	  var self = {
	    clear: function clear() {
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      reset();
	    },
	    destroy: function destroy() {
	      stopDrawing();
	      stopDraggingSelection();
	      tmp_canvas.removeEventListener('pointerdown', startDrawing, false);
	      document.removeEventListener('pointercancel', stopDrawing);
	      select_canvas.removeEventListener('pointerdown', startDraggingSelection, false);
	    },
	    download: function download() {
	      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'download.png';
	
	      if (!state.readyForSave) {
	        return false;
	      }
	
	      var lnk = document.createElement('a'),
	          c = document.createElement('canvas'),
	          e;
	
	      var scale = 4;
	      c.width = canvas.width * scale;
	      c.height = canvas.height * scale;
	      var cx = c.getContext('2d');
	      cx.mozImageSmoothingEnabled = false;
	      cx.webkitImageSmoothingEnabled = false;
	      cx.msImageSmoothingEnabled = false;
	      cx.imageSmoothingEnabled = false;
	      cx.fillStyle = state.backgroundColor;
	      cx.fillRect(0, 0, c.width, c.height);
	      cx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, c.width, c.height);
	
	      cx.drawImage(overlay_canvas, 0, 0, canvas.width, canvas.height, 0, 0, c.width, c.height);
	
	      if (navigator && navigator.msSaveBlob) {
	        (0, _download3.default)(c.toDataURL(), filename, 'image/png');
	        return;
	      }
	
	      lnk.download = filename;
	
	      lnk.href = c.toDataURL();
	      lnk.target = '_blank';
	
	      if (document.createEvent) {
	
	        e = document.createEvent("MouseEvents");
	        e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	        lnk.dispatchEvent(e);
	      } else if (lnk.fireEvent) {
	
	        lnk.fireEvent("onclick");
	      }
	      return true;
	    },
	    undo: function undo() {
	      if (state.undoEnabled) {
	        if (previous_ctx) {
	          ctx.drawImage(previous_ctx.canvas, 0, 0);
	        }
	        state.undoEnabled = false;
	      } else {
	        if (redo_ctx) {
	          ctx.drawImage(redo_ctx.canvas, 0, 0);
	          state.undoEnabled = true;
	        }
	      }
	    },
	    loadImage: function loadImage(src) {
	      reset(false);
	      (0, _imageLoader2.default)(src).then(function (img) {
	        var x = (img.width - canvas.width) / 2;
	        var y = (img.height - canvas.height) / 2;
	
	        ctx.drawImage(img, -x, -y);
	
	        state.readyForSave = true;
	      });
	    },
	    onToolChange: function onToolChange() {
	      clearSelection();
	    }
	  };
	
	  window.paint = self;
	  return self;
	};
	
	exports.default = canvasPaint;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canvasUtil = {
	  drawRoundRect: function drawRoundRect(ctx, x, y, width, height, radius, fill, stroke) {
	    if (typeof fill === "undefined") {
	      fill = true;
	    }
	    if (typeof stroke === "undefined") {
	      stroke = false;
	    }
	    if (typeof radius === "undefined") {
	      radius = 3;
	    }
	    ctx.save();
	    ctx.beginPath();
	    ctx.moveTo(x + radius, y);
	    ctx.lineTo(x + width - radius, y);
	    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
	    ctx.lineTo(x + width, y + height - radius);
	    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
	    ctx.lineTo(x + radius, y + height);
	    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
	    ctx.lineTo(x, y + radius);
	    ctx.quadraticCurveTo(x, y, x + radius, y);
	    ctx.closePath();
	    if (stroke) {
	      ctx.stroke();
	    }
	    if (fill) {
	      ctx.fill();
	    }
	    ctx.restore();
	  }
	
	};
	
	exports.default = canvasUtil;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(88);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	    module.exports = factory();
	  } else {
	    root.download = factory();
	  }
	})(undefined, function () {
	
	  return function download(data, strFileName, strMimeType) {
	
	    var self = window,
	        defaultMime = "application/octet-stream",
	        mimeType = strMimeType || defaultMime,
	        payload = data,
	        url = !strFileName && !strMimeType && payload,
	        anchor = document.createElement("a"),
	        toString = function toString(a) {
	      return String(a);
	    },
	        myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
	        fileName = strFileName || "download",
	        blob,
	        reader;
	    myBlob = myBlob.call ? myBlob.bind(self) : Blob;
	
	    if (String(this) === "true") {
	      payload = [payload, mimeType];
	      mimeType = payload[0];
	      payload = payload[1];
	    }
	
	    if (url && url.length < 2048) {
	      fileName = url.split("/").pop().split("?")[0];
	      anchor.href = url;
	      if (anchor.href.indexOf(url) !== -1) {
	        var ajax = new XMLHttpRequest();
	        ajax.open("GET", url, true);
	        ajax.responseType = 'blob';
	        ajax.onload = function (e) {
	          download(e.target.response, fileName, defaultMime);
	        };
	        setTimeout(function () {
	          ajax.send();
	        }, 0);
	        return ajax;
	      }
	    }
	    if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {
	
	      if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
	        payload = dataUrlToBlob(payload);
	        mimeType = payload.type || defaultMime;
	      } else {
	        return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload);
	      }
	    }
	
	    blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });
	
	    function dataUrlToBlob(strUrl) {
	      var parts = strUrl.split(/[:;,]/),
	          type = parts[1],
	          decoder = parts[2] == "base64" ? atob : decodeURIComponent,
	          binData = decoder(parts.pop()),
	          mx = binData.length,
	          i = 0,
	          uiArr = new Uint8Array(mx);
	
	      for (i; i < mx; ++i) {
	        uiArr[i] = binData.charCodeAt(i);
	      }return new myBlob([uiArr], { type: type });
	    }
	
	    function saver(url, winMode) {
	
	      if ('download' in anchor) {
	        anchor.href = url;
	        anchor.setAttribute("download", fileName);
	        anchor.className = "download-js-link";
	        anchor.innerHTML = "downloading...";
	        anchor.style.display = "none";
	        document.body.appendChild(anchor);
	        setTimeout(function () {
	          anchor.click();
	          document.body.removeChild(anchor);
	          if (winMode === true) {
	            setTimeout(function () {
	              self.URL.revokeObjectURL(anchor.href);
	            }, 250);
	          }
	        }, 66);
	        return true;
	      }
	
	      if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
	        url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
	        if (!window.open(url)) {
	          if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
	            location.href = url;
	          }
	        }
	        return true;
	      }
	
	      var f = document.createElement("iframe");
	      document.body.appendChild(f);
	
	      if (!winMode) {
	        url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
	      }
	      f.src = url;
	      setTimeout(function () {
	        document.body.removeChild(f);
	      }, 333);
	    }
	
	    if (navigator.msSaveBlob) {
	      return navigator.msSaveBlob(blob, fileName);
	    }
	
	    if (self.URL) {
	      saver(self.URL.createObjectURL(blob), true);
	    } else {
	      if (typeof blob === "string" || blob.constructor === toString) {
	        try {
	          return saver("data:" + mimeType + ";base64," + self.btoa(blob));
	        } catch (y) {
	          return saver("data:" + mimeType + "," + encodeURIComponent(blob));
	        }
	      }
	
	      reader = new FileReader();
	      reader.onload = function (e) {
	        saver(this.result);
	      };
	      reader.readAsDataURL(blob);
	    }
	    return true;
	  };
	});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function floodfill(data, x, y, fillcolor, tolerance, width, height) {
	
	  var length = data.length;
	  var Q = [];
	  var i = (x + y * width) * 4;
	  var e = i,
	      w = i,
	      me,
	      mw,
	      w2 = width * 4;
	
	  var targetcolor = [data[i], data[i + 1], data[i + 2], data[i + 3]];
	
	  if (!pixelCompare(i, targetcolor, fillcolor, data, length, tolerance)) {
	    return false;
	  }
	  Q.push(i);
	  while (Q.length) {
	    i = Q.pop();
	    if (pixelCompareAndSet(i, targetcolor, fillcolor, data, length, tolerance)) {
	      e = i;
	      w = i;
	      mw = parseInt(i / w2) * w2;
	      me = mw + w2;
	      while (mw < w && mw < (w -= 4) && pixelCompareAndSet(w, targetcolor, fillcolor, data, length, tolerance)) {}
	      while (me > e && me > (e += 4) && pixelCompareAndSet(e, targetcolor, fillcolor, data, length, tolerance)) {}
	      for (var j = w; j < e; j += 4) {
	        if (j - w2 >= 0 && pixelCompare(j - w2, targetcolor, fillcolor, data, length, tolerance)) Q.push(j - w2);
	        if (j + w2 < length && pixelCompare(j + w2, targetcolor, fillcolor, data, length, tolerance)) Q.push(j + w2);
	      }
	    }
	  }
	  return data;
	}
	
	function pixelCompare(i, targetcolor, fillcolor, data, length, tolerance) {
	  if (i < 0 || i >= length) return false;
	  if (data[i + 3] === 0 && fillcolor.a > 0) return true;
	
	  if (Math.abs(targetcolor[3] - fillcolor.a) <= tolerance && Math.abs(targetcolor[0] - fillcolor.r) <= tolerance && Math.abs(targetcolor[1] - fillcolor.g) <= tolerance && Math.abs(targetcolor[2] - fillcolor.b) <= tolerance) return false;
	
	  if (targetcolor[3] === data[i + 3] && targetcolor[0] === data[i] && targetcolor[1] === data[i + 1] && targetcolor[2] === data[i + 2]) return true;
	
	  if (Math.abs(targetcolor[3] - data[i + 3]) <= 255 - tolerance && Math.abs(targetcolor[0] - data[i]) <= tolerance && Math.abs(targetcolor[1] - data[i + 1]) <= tolerance && Math.abs(targetcolor[2] - data[i + 2]) <= tolerance) return true;
	
	  return false;
	}
	
	function pixelCompareAndSet(i, targetcolor, fillcolor, data, length, tolerance) {
	  if (pixelCompare(i, targetcolor, fillcolor, data, length, tolerance)) {
	    data[i] = fillcolor.r;
	    data[i + 1] = fillcolor.g;
	    data[i + 2] = fillcolor.b;
	    data[i + 3] = fillcolor.a;
	    return true;
	  }
	  return false;
	}
	
	function fillUint8ClampedArray(data, x, y, color, tolerance, width, height) {
	  console.log('fill', arguments);
	  if (!data instanceof Uint8ClampedArray) throw new Error("data must be an instance of Uint8ClampedArray");
	  if (isNaN(width) || width < 1) throw new Error("argument 'width' must be a positive integer");
	  if (isNaN(height) || height < 1) throw new Error("argument 'height' must be a positive integer");
	  if (isNaN(x) || x < 0) throw new Error("argument 'x' must be a positive integer");
	  if (isNaN(y) || y < 0) throw new Error("argument 'y' must be a positive integer");
	  if (width * height * 4 !== data.length) throw new Error("width and height do not fit Uint8ClampedArray dimensions");
	
	  var xi = Math.floor(x);
	  var yi = Math.floor(y);
	
	  if (xi !== x) console.warn("x truncated from", x, "to", xi);
	  if (yi !== y) console.warn("y truncated from", y, "to", yi);
	
	  tolerance = !isNaN(tolerance) ? Math.min(Math.abs(Math.round(tolerance)), 254) : 0;
	
	  return floodfill(data, xi, yi, color, tolerance, width, height);
	}
	
	function getComputedColor(c) {
	  var temp = document.createElement("div");
	  var color = { r: 0, g: 0, b: 0, a: 0 };
	  temp.style.color = c;
	  temp.style.display = "none";
	  document.body.appendChild(temp);
	
	  var style = window.getComputedStyle(temp, null).color;
	  document.body.removeChild(temp);
	
	  var recol = /([\.\d]+)/g;
	  var vals = style.match(recol);
	  if (vals && vals.length > 2) {
	    color.r = parseInt(vals[0]) || 0;
	    color.g = parseInt(vals[1]) || 0;
	    color.b = parseInt(vals[2]) || 0;
	    color.a = Math.round((parseFloat(vals[3]) || 1.0) * 255);
	  }
	  return color;
	}
	
	function fillContext(ctx, color, x, y, tolerance, left, top, right, bottom) {
	  color = getComputedColor(color);
	
	  left = isNaN(left) ? 0 : left;
	  top = isNaN(top) ? 0 : top;
	  right = !isNaN(right) && right ? Math.min(Math.abs(right), ctx.canvas.width) : ctx.canvas.width;
	  bottom = !isNaN(bottom) && bottom ? Math.min(Math.abs(bottom), ctx.canvas.height) : ctx.canvas.height;
	
	  var image = ctx.getImageData(left, top, right, bottom);
	
	  var data = image.data;
	  var width = image.width;
	  var height = image.height;
	
	  if (width > 0 && height > 0) {
	    fillUint8ClampedArray(data, x, y, color, tolerance, width, height);
	    ctx.putImageData(image, left, top);
	  }
	}
	
	exports.default = fillContext;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaintApp = __webpack_require__(53);
	
	var _PaintApp2 = _interopRequireDefault(_PaintApp);
	
	var _BootScreen = __webpack_require__(192);
	
	var _BootScreen2 = _interopRequireDefault(_BootScreen);
	
	var _DosExecutive = __webpack_require__(193);
	
	var _DosExecutive2 = _interopRequireDefault(_DosExecutive);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  components: {
	    PaintApp: _PaintApp2.default,
	    BootScreen: _BootScreen2.default,
	    DosExecutive: _DosExecutive2.default
	  },
	
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  },
	  ready: function ready() {
	    this.$on('goNext', this.goNext);
	  },
	  beforeDestroy: function beforeDestroy() {},
	
	  methods: {
	    goNext: function goNext() {
	      _state2.default.currentView = _config2.default.devMode ? 'paint-app' : 'dos-executive';
	    }
	  }
	
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaintApp = __webpack_require__(53);
	
	var _PaintApp2 = _interopRequireDefault(_PaintApp);
	
	var _Colors = __webpack_require__(56);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Brushes = __webpack_require__(55);
	
	var _Brushes2 = _interopRequireDefault(_Brushes);
	
	var _LineWidths = __webpack_require__(57);
	
	var _LineWidths2 = _interopRequireDefault(_LineWidths);
	
	var _OpenDialog = __webpack_require__(58);
	
	var _OpenDialog2 = _interopRequireDefault(_OpenDialog);
	
	var _SaveDialog = __webpack_require__(59);
	
	var _SaveDialog2 = _interopRequireDefault(_SaveDialog);
	
	var _Share = __webpack_require__(60);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default,
	      config: _config2.default
	
	    };
	  },
	
	
	  components: {
	    Paint: _PaintApp2.default,
	
	    Colors: _Colors2.default,
	    Brushes: _Brushes2.default,
	    LineWidths: _LineWidths2.default,
	    Share: _Share2.default
	  },
	
	  methods: {
	    download: function download() {
	      window.paint.download();
	    },
	    undo: function undo() {
	      window.paint.undo();
	    },
	    redo: function redo() {
	      window.paint.redo();
	    },
	    reset: function reset() {
	      window.paint.clear(true);
	    }
	  },
	
	  ready: function ready() {
	    var vm = this;
	
	    setTimeout(function () {}, 4000);
	  }
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(189);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Dev = __webpack_require__(190);
	
	var _Dev2 = _interopRequireDefault(_Dev);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subviews = ['app', 'dev'];
	
	var vue = {
	  data: function data() {
	    return {
	      currentView: null
	    };
	  },
	
	  components: {
	    App: _App2.default,
	    Dev: _Dev2.default
	  },
	
	  ready: function ready() {
	    $(window).on('hashchange', this.updateCurrentView);
	    $(window).on('resize', this.onResize);
	    $(window).on('orientationchange', this.onResize);
	
	    $(this.$el).addClass('ready');
	
	    this.updateCurrentView();
	    _.defer(this.onResize);
	
	    this.flickerAmount = 1.0;
	    this.flicker();
	
	    this.flickerTimeout = setTimeout(this.stopFlickering, 11 * 1000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    $(window).off('hashchange', this.updateCurrentView);
	    $(window).off('resize', this.onResize);
	    $(window).off('orientationchange', this.onResize);
	
	    clearTimeout(this.flickerTimeout);
	    this.stopFlickering();
	  },
	
	
	  methods: {
	    onResize: _.throttle(function () {
	
	      var body = document.querySelector('body');
	      var el = this.$el;
	
	      if (body && el) {
	        var body_rect = body.getBoundingClientRect();
	        var el_rect = el.getBoundingClientRect();
	        var x = Math.max(Math.round(0.5 * ($(window).width() - el_rect.width)), 0);
	        var y = Math.max(Math.round(0.48 * ($(window).height() - el_rect.height)), 0);
	
	        TweenLite.set(el, { x: x, y: y, alpha: 1.0 });
	
	        $('body').scrollTop(1);
	      }
	    }, 200),
	
	    updateCurrentView: function updateCurrentView() {
	      this.currentView = viewForHash(document.location.hash);
	    },
	    flicker: function flicker() {
	      if (_config2.default.devMode) return;
	
	      var d = 0 - this.flickerAmount;
	      this.flickerAmount += .005 * d;
	      TweenLite.set('.app-content', { opacity: Math.random() * (.0789 * this.flickerAmount) + .789 });
	
	      if (Math.abs(d) > .1) {
	        window.requestAnimationFrame(this.flicker);
	      } else {}
	    },
	    stopFlickering: function stopFlickering() {
	      this.flickerAmount = 0;
	    }
	  }
	};
	
	function viewForHash(hash) {
	  hash = hash.replace('#', '');
	  if (hash.indexOf('/') == 0) hash = hash.substr(1);
	  var splat = hash.split('/');
	  var idx = subviews.indexOf(splat[0]);
	  if (idx < 0) idx = 0;
	  return subviews[idx];
	}
	
	exports.default = vue;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var intro_src = __webpack_require__(168);
	
	exports.default = {
	
	  methods: {
	    goNext: function goNext() {
	      this.$dispatch('goNext');
	    }
	  },
	
	  ready: function ready() {
	    var delay = _config2.default.devMode ? 0 : 6000;
	    setTimeout(this.goNext, delay);
	
	    var img = new Image();
	    img.src = intro_src + '?v=' + +new Date();
	    if (!_config2.default.devMode) setTimeout(function () {
	      $('.boot-screen').empty().append($(img).addClass('screenshot'));
	    }, 10);
	  }
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['showDisk'],
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  },
	  ready: function ready() {},
	  beforeDestroy: function beforeDestroy() {},
	
	
	  methods: {
	    thisIsAllFake: function thisIsAllFake() {
	      return true;
	    }
	  }
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _each2 = __webpack_require__(48);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _isFunction2 = __webpack_require__(30);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _BottomBar = __webpack_require__(52);
	
	var _BottomBar2 = _interopRequireDefault(_BottomBar);
	
	var _WinHeader = __webpack_require__(54);
	
	var _WinHeader2 = _interopRequireDefault(_WinHeader);
	
	var _DosFileMenu = __webpack_require__(194);
	
	var _DosFileMenu2 = _interopRequireDefault(_DosFileMenu);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      config: _config2.default,
	      state: _state2.default
	    };
	  },
	
	  components: {
	    BottomBar: _BottomBar2.default,
	    WinHeader: _WinHeader2.default,
	    DosFileMenu: _DosFileMenu2.default
	
	  },
	  methods: {
	    runCommand: function runCommand(e) {
	      var $btn = $(e.target);
	      var cmd = $btn.data('cmd');
	      var arg = $btn.data('arg');
	      if (cmd && (0, _isFunction3.default)(this[cmd])) {
	        this[cmd].call(this, arg);
	      } else {
	        if (_state2.default && (0, _isFunction3.default)(_state2.default[cmd])) {
	          _state2.default[cmd].call(_state2.default, arg);
	        } else {}
	      }
	    },
	    PAINT: function PAINT() {
	      console.log('PAINT', _state2.default);
	      _state2.default.currentView = 'paint-app';
	    },
	    blink: function blink() {
	      $(this.$el).toggleClass('blink');
	    }
	  },
	  ready: function ready() {
	    $(this.$el).on('click', '*[data-cmd]', this.runCommand);
	    if (!_config2.default.devMode) this.blinkInt = setInterval(this.blink, 600);
	
	    var $background = $('.background', this.$el);
	
	
	    var $children = [$('.top-bar', this.$el), $('.menu-bar', this.$el), $('.file-window', this.$el), $('.drive-list', this.$el), $('.file-list', this.$el)];
	
	    (0, _each3.default)($children, function ($child, i) {
	      var delay = .75 + i * (.2 + Math.random() * .1);
	      TweenLite.set($child, { opacity: 0 });
	      TweenLite.to($child, .12, { delay: delay, opacity: 1.0 });
	    });
	
	    TweenLite.set($background, { opacity: 1.0 });
	    TweenLite.to($background, .5, { opacity: 0, delay: 4 });
	
	
	    this.tweenedThings = $children.concat($background);
	  },
	  onBeforeDestroy: function onBeforeDestroy() {
	    $(this.$el).off('click', '*[data-cmd]', this.runCommand);
	    clearInterval(this.blinkInt);
	    if (this.tweenedThings) {
	      TweenLite.killTweensOf(this.tweenedThings);
	    }
	  }
	};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  ready: function ready() {},
	  beforeDestroy: function beforeDestroy() {},
	
	
	  methods: {
	    thisIsAllFake: function thisIsAllFake() {
	      return true;
	    }
	  }
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _canvasPaint = __webpack_require__(63);
	
	var _canvasPaint2 = _interopRequireDefault(_canvasPaint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var p = void 0;
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  },
	  ready: function ready() {
	    p = (0, _canvasPaint2.default)(this.$el, _state2.default);
	  },
	  beforeDestroy: function beforeDestroy() {
	    p.destroy();
	  }
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      config: _config2.default,
	      state: _state2.default
	    };
	  },
	  ready: function ready() {
	    this.$menuItems = $(this.$el).find('.menu-item');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeCloseHandler();
	  },
	
	
	  methods: {
	    onMenuTap: function onMenuTap(e) {
	      var $btn = $(e.target);
	      if ($btn.is('.menu-item')) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        this.openPopup($btn.index());
	      } else {
	        return true;
	      }
	    },
	    onMenuClick: function onMenuClick(e) {
	      var $btn = $(e.target);
	      if ($btn.is('.menu-item')) {
	        e.stopImmediatePropagation();
	      }
	    },
	    openPopup: function openPopup(idx) {
	      var $btn = this.$menuItems.eq(idx);
	
	      if ($btn.is('.open')) {
	        this.closePopups();
	      } else {
	        this.closePopups();
	
	        $btn.addClass('open');
	
	        this.closeOnClick();
	      }
	    },
	    closePopups: function closePopups() {
	      this.removeCloseHandler();
	      this.$menuItems.removeClass('open');
	    },
	    closeOnClick: function closeOnClick() {
	      this.removeCloseHandler();
	      $(document).on('click', this.closePopups);
	    },
	    removeCloseHandler: function removeCloseHandler() {
	      $(document).off('click', this.closePopups);
	    }
	  }
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _each2 = __webpack_require__(48);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _isFunction2 = __webpack_require__(30);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _BottomBar = __webpack_require__(52);
	
	var _BottomBar2 = _interopRequireDefault(_BottomBar);
	
	var _DrawingPanel = __webpack_require__(195);
	
	var _DrawingPanel2 = _interopRequireDefault(_DrawingPanel);
	
	var _ToolBar = __webpack_require__(198);
	
	var _ToolBar2 = _interopRequireDefault(_ToolBar);
	
	var _WinHeader = __webpack_require__(54);
	
	var _WinHeader2 = _interopRequireDefault(_WinHeader);
	
	var _FileMenu = __webpack_require__(196);
	
	var _FileMenu2 = _interopRequireDefault(_FileMenu);
	
	var _Palettes = __webpack_require__(197);
	
	var _Palettes2 = _interopRequireDefault(_Palettes);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      config: _config2.default,
	      state: _state2.default
	    };
	  },
	
	  components: {
	    BottomBar: _BottomBar2.default,
	    WinHeader: _WinHeader2.default,
	    FileMenu: _FileMenu2.default,
	    DrawingPanel: _DrawingPanel2.default,
	    ToolBar: _ToolBar2.default,
	    Palettes: _Palettes2.default
	  },
	  methods: {
	    runCommand: function runCommand(e) {
	      var $btn = $(e.target);
	      var cmd = $btn.data('cmd');
	      var arg = $btn.data('arg');
	
	      if (cmd && (0, _isFunction3.default)(this[cmd])) {
	        console.log('Running App Command', cmd, arg);
	        this[cmd].call(this, arg);
	      } else {
	        if (_state2.default && (0, _isFunction3.default)(_state2.default[cmd])) {
	          console.log('Running State Command', cmd, arg);
	          _state2.default[cmd].call(_state2.default, arg);
	        } else {
	          console.log('Command not found', cmd);
	        }
	      }
	    },
	    new: function _new() {
	      window.paint.clear();
	      _state2.default.title = '(untitled)';
	    },
	    save: function save() {
	      if (window.paint.download()) {
	        _state2.default.title = 'MYPICTU~.PNG';
	      }
	    },
	    erase: function erase() {
	      window.paint.clear();
	      _state2.default.title = '(untitled)';
	    },
	    undo: function undo() {
	      window.paint.undo();
	    },
	    redo: function redo() {
	      window.paint.redo();
	    },
	    share: function share(site) {
	
	      var url;
	
	      switch (site) {
	        case 'twitter':
	          url = 'http://twitter.com/intent/tweet?status=' + (_config2.default.shareTitle + ' ' + _config2.default.shareUrl);
	          break;
	        case 'facebook':
	          url = 'http://www.facebook.com/sharer/sharer.php?u=' + _config2.default.shareUrl + '&title=' + _config2.default.shareTitle;
	          break;
	
	      }
	
	      if (url) {
	        document.location.href = url;
	      }
	    },
	    backToDos: function backToDos() {
	      _state2.default.currentView = 'dos-executive';
	    }
	  },
	  ready: function ready() {
	    _state2.default.setTool('pencil');
	    $(this.$el).on('click', '*[data-cmd]', this.runCommand);
	
	    var $background = $('.background', this.$el);
	    var $background2 = $('.background2', this.$el);
	
	    var $children = [$('.top-bar', this.$el), $('.menu-bar', this.$el), $('.toolbar', this.$el), $('.bottom-bar', this.$el), $('.drawing-panel', this.$el), $('.info-panel', this.$el), $('.tools', this.$el), $('.drawing-canvas', this.$el)];
	
	    (0, _each3.default)($children, function ($child, i) {
	      var delay = .75 + i * (.2 + Math.random() * .1);
	      TweenLite.set($child, { opacity: 0 });
	      TweenLite.to($child, .12, { delay: delay, opacity: 1.0 });
	    });
	
	    TweenLite.set($background, { opacity: 1.0 });
	    TweenLite.to($background, .5, { opacity: 0, delay: 4 });
	
	    TweenLite.set($background2, { opacity: 0 });
	    TweenLite.to($background2, .15, { opacity: 1, delay: 1.25 });
	    TweenLite.to($background2, .5, { opacity: 0, delay: 4 });
	
	    this.tweenedThings = $children.concat([$background, $background2]);
	  },
	  onBeforeDestroy: function onBeforeDestroy() {
	    $(this.$el).off('click', '*[data-cmd]', this.runCommand);
	
	    if (this.tweenedThings) {
	      TweenLite.killTweensOf(this.tweenedThings);
	    }
	  }
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Colors = __webpack_require__(56);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Brushes = __webpack_require__(55);
	
	var _Brushes2 = _interopRequireDefault(_Brushes);
	
	var _LineWidths = __webpack_require__(57);
	
	var _LineWidths2 = _interopRequireDefault(_LineWidths);
	
	var _OpenDialog = __webpack_require__(58);
	
	var _OpenDialog2 = _interopRequireDefault(_OpenDialog);
	
	var _SaveDialog = __webpack_require__(59);
	
	var _SaveDialog2 = _interopRequireDefault(_SaveDialog);
	
	var _Share = __webpack_require__(60);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  },
	
	  components: {
	    Colors: _Colors2.default,
	    Brushes: _Brushes2.default,
	    LineWidths: _LineWidths2.default,
	    OpenDialog: _OpenDialog2.default,
	    SaveDialog: _SaveDialog2.default,
	    Share: _Share2.default
	  },
	  methods: {
	    onPaletteClick: function onPaletteClick(e) {
	      e.stopImmediatePropagation();
	    },
	    transitionIn: function transitionIn() {
	
	      TweenLite.set('.palette-border', { opacity: 0 });
	      TweenLite.to('.palette-border', .1, { delay: .15 + Math.random() * .15, opacity: 1.0 });
	
	      var $content = $('.palette-content > *', this.$el);
	      var $cover = $('.palette-cover', this.$el);
	      var h = $content.height();
	      TweenLite.set($cover, { height: h, top: 0 });
	      TweenLite.to($cover, .789, { delay: .5 + Math.random() * .2, height: 0, top: h, ease: 'linear' });
	    }
	  },
	
	  ready: function ready() {
	    var _this = this;
	
	    this.$watch('state.paletteView', function () {
	      if (_state2.default.paletteView) {
	        _this.transitionIn();
	      }
	    });
	  }
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _filterImage = __webpack_require__(33);
	
	var _filterImage2 = _interopRequireDefault(_filterImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clear(ctx) {
	  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
	}
	
	function drawCircle(ctx, x, y, r) {
	  r = Math.abs(r);
	  ctx.save();
	  ctx.beginPath();
	  ctx.arc(x, y, r, 0, Math.PI * 2);
	  ctx.restore();
	}
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  },
	
	  methods: {
	    selectTool: function selectTool(event) {
	      var tool = event.target.id.split('-').pop();
	
	      _state2.default.setTool(tool);
	    }
	  },
	
	  ready: function ready() {
	
	    clearInterval(this.brushUpdateInterval);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.brushUpdateInterval);
	  }
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['title'],
	  data: function data() {
	    return {
	      config: _config2.default,
	      state: _state2.default
	    };
	  }
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  }
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  }
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  }
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      NINJACAT: 'NINJACAT.BMP',
	      WALLPAPER: 'WALL2016.PNG',
	      state: _state2.default,
	      selectedFile: '*.BMP'
	    };
	  },
	
	
	  methods: {
	    selectFile: function selectFile(f) {
	      if (!f) f = '*.BMP';
	      this.selectedFile = f;
	    },
	    openFile: function openFile() {
	
	      switch (this.selectedFile) {
	
	        case this.NINJACAT:
	          window.paint.loadImage(_config2.default.overlayArtwork);
	          _state2.default.title = this.NINJACAT;
	          _state2.default.closePalette();
	          break;
	
	        case this.WALLPAPER:
	          _state2.default.closePalette();
	          break;
	
	      }
	    }
	  },
	
	  ready: function ready() {
	    this.selectFile(null);
	  }
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  }
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: _state2.default
	    };
	  }
	};

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/brushes.39c3bb7.png";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhIAAgAJEAAP8AAP///wAAAAAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMTEgNzkuMTU4MzI1LCAyMDE1LzA5LzEwLTAxOjEwOjIwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCNjJFNDUxMDZFNTYxMUU2QjcxQkJBQUI5QkIxMjVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCNjJFNDUxMTZFNTYxMUU2QjcxQkJBQUI5QkIxMjVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE0Njg0NzZCNkU1NjExRTZCNzFCQkFBQjlCQjEyNUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjE0Njg0NzZDNkU1NjExRTZCNzFCQkFBQjlCQjEyNUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAAAsAAAAACAAIAAAAkeUj6nL7Q9jC7RaK9HdNR/OeQa4iQJ5OcAKmCrrNmwb17YE38hM6/yqE/x6tmHQeJwFD7ml8wmNSkUBaTV6hWafW2d3+XUUAAA7"

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hashtag5.ef6a876.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/intro.trim.black.7be376f.gif";

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDQyRjk2Mjg3ODUwMTFFNjhDRjFGQjM4RTkyQjdGQUQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDQyRjk2Mjk3ODUwMTFFNjhDRjFGQjM4RTkyQjdGQUQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGREY3QUY3Rjc3QjYxMUU2OENGMUZCMzhFOTJCN0ZBRCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGREY3QUY4MDc3QjYxMUU2OENGMUZCMzhFOTJCN0ZBRCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PulO+1QAAAAGUExURampqQAAANYgUoEAAAABdFJOUwBA5thmAAAAIklEQVR42mJgIBkwMhIjiBBAksIqSH1TB9JuUk0lAgAEGAApBAAx5r/M2QAAAABJRU5ErkJggg=="

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports = " <div id=dev class=clearfix> <div class=\"panel clearfix\"> <h1> Vostock - <strong>v{{ config.VERSION }} [<em>mode={{ config.ENV }}</em>]</strong> </h1> <div class=dev-controls> <button v-on:click=state.toggleColorDisplay()> <label v-if=state.colorDisplay>View B/W</label> <label v-else>View Color</label> </button> <button v-on:click=undo><label>Undo</label></button> <button v-on:click=redo><label>Redo</label></button> <button v-on:click=download><label>Download</label></button> <button v-on:click=reset><label>Reset</label></button> <label class=\"color-picker size-sm\" v-bind:style=\"{ 'background-color': state.color }\"> <input type=color v-model=state.color> </label> <input type=number v-model=state.lineWidth step=2 min=2 max=32> </div> <section id=paint> <paint></paint> <div class=palette> <div class=palette-border> <line-widths></line-widths> </div> </div> <div class=palette> <div class=palette-border> <colors></colors> </div> </div> <div class=palette> <div class=palette-border> <brushes></brushes> </div> </div> </section> </div> </div> ";

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports = " <div id=main> <component :is=currentView></component> </div> ";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"boot-screen stretchy\" v-on:click=goNext> </div> ";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"bottom-bar greentone\"> <img src=" + __webpack_require__(166) + " data-cmd=save v-if=\"showDisk && state.readyForSave\"> </div> ";

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	module.exports = " <div class=menu-bar> <ul> <li class=menu-item><label>File</label></li> <li class=menu-item><label>View</label></li> <li class=menu-item><label>Special</label> </li> </ul> </div> ";

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"drawing-panel halftone container\"> <div class=\"drawing-canvas overlay tool-cursor-{{ state.tool }}\"> <canvas id=paintcanvas width=512 height=288></canvas> </div> </div> ";

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = " <div class=menu-bar> <ul v-on:click=onMenuTap v-on:click=onMenuClick> <li class=menu-item><label>File</label> <ul class=dropdown> <li data-cmd=new><label>New</label></li> <li data-cmd=showPalette data-arg=open-dialog><label>Open...</label></li> <li data-cmd=save><label>Save...</label></li> </ul> </li> <li class=menu-item><label>Edit</label> <ul class=dropdown> <li data-cmd=undo><label>Undo</label></li> <li data-cmd=erase><label>Erase</label></li> </ul> </li> <li class=menu-item><label>Palette</label> <ul class=dropdown> <li data-cmd=showPalette data-arg=colors><label>Colors...</label></li> <li data-cmd=showPalette data-arg=line-widths><label>Line Widths...</label></li> <li data-cmd=showPalette data-arg=brushes><label>Brush Shapes...</label></li> </ul> </li> <li class=menu-item><label>Options</label> <ul class=dropdown> <li data-cmd=setGrid data-arg=0 v-bind:class=\"{checked: state.grid==0}\"><label>No Grid</label></li> <li data-cmd=setGrid data-arg=1 v-bind:class=\"{checked: state.grid==1}\"><label>Fine Grid</label></li> <li data-cmd=setGrid data-arg=2 v-bind:class=\"{checked: state.grid==2}\"><label>Medium Grid</label></li> <li data-cmd=setGrid data-arg=3 v-bind:class=\"{checked: state.grid==3}\"><label>Coarse Grid</label></li> </ul> </li> </ul> </div> ";

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"paint-app pixelated\" v-bind:class=\"{color: state.colorDisplay }\"> <div class=\"background overlay stretchy greentone\" style=\"z-index: -2\"></div> <div class=\"background2 overlay stretchy halftone\" style=\"z-index: -1\"></div> <win-header v-bind:title=\"'Paint - '+ state.title\"></win-header> <file-menu></file-menu> <tool-bar></tool-bar> <drawing-panel></drawing-panel> <bottom-bar show-disk=1></bottom-bar> <palettes></palettes> </div> ";

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"palette-modal stretchy container\" v-bind:class=\"{ open: state.paletteView!=null }\"> <div class=\"stretchy background-cover\" v-on:click=state.closePalette()></div> <div class=\"palette total-center\"> <div class=palette-border> <div class=palette-content> <component :is=state.paletteView></component> <div class=palette-cover></div> </div> </div> </div> </div> ";

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = " <div class=top-bar> <button class=left data-cmd=backToDos></button> <button class=right data-cmd=toggleZoom></button> <h2><label>{{ title }}</label></h2> </div> ";

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"brush-palette clearfix\"> <div v-for=\"(idx, brush) in state.AVAILABLE_BRUSHES\" class=\"palette-button brush-palette-item\" data-cmd=setBrush data-arg=\"{{ idx }}\"> <div class=\"brush-icon brush-icon-idx\" v-bind:style=\"{'background-position': brush.backgroundPosition}\"></div> </div> </div> ";

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = " <section id=app _v-1cf2c037=\"\"> <div class=app-content _v-1cf2c037=\"\"> <component :is=state.currentView _v-1cf2c037=\"\"></component> </div> </section> ";

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"color-palette clearfix\" _v-3488a6e8=\"\"> <div class=\"palette-button color-palette-item\" data-cmd=setColor data-arg=\"{{ color }}\" v-for=\"(idx, color) in state.AVAILABLE_COLORS\" _v-3488a6e8=\"\"> <div class=color-fill v-bind:style=\"{ 'background-color': color }\" _v-3488a6e8=\"\"></div> </div> </div> ";

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"toolbar halftone clearfix\" _v-3f27c2fc=\"\"> <div class=info-panel _v-3f27c2fc=\"\"> <button class=selected-tool _v-3f27c2fc=\"\"><span class=\"icon-{{ state.tool }}\" _v-3f27c2fc=\"\"></span></button> <button class=selected-color data-cmd=showPalette data-arg=colors _v-3f27c2fc=\"\"> <div v-bind:style=\"{ 'background-color': state.color }\" _v-3f27c2fc=\"\"></div> </button> <button class=selected-brush data-cmd=showPalette data-arg=brushes _v-3f27c2fc=\"\"> <div class=brush-icon v-bind:style=\"{ backgroundPosition: state.selectedBrush.backgroundPosition }\" _v-3f27c2fc=\"\"></div> </button> <button class=selected-line-width data-cmd=showPalette data-arg=line-widths _v-3f27c2fc=\"\"> <div class=\"line-icon line-icon-{{ Math.floor(state.lineWidth) }}\" _v-3f27c2fc=\"\"></div> </button> </div> <div class=tools v-on:click=selectTool _v-3f27c2fc=\"\"> <span v-for=\"tool in state.TOOLS\" _v-3f27c2fc=\"\"> <button id=\"btn-{{ tool }}\" v-bind:class=\"{ selected: state.tool==tool, disabled: !state.isToolEnabled(tool) }\" _v-3f27c2fc=\"\"> <span class=\"icon-{{ tool }}\" _v-3f27c2fc=\"\"></span> </button> </span> </div> </div> ";

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"linewidth-palette clearfix\" _v-54ade979=\"\"> <div class=\"palette-button line-palette-item\" data-cmd=setLineWidth data-arg=.5 _v-54ade979=\"\"> <div class=\"line-icon line-icon-0\" _v-54ade979=\"\"></div> </div> <div class=\"palette-button line-palette-item\" data-cmd=setLineWidth data-arg=1 _v-54ade979=\"\"> <div class=\"line-icon line-icon-1\" _v-54ade979=\"\"></div> </div> <div class=\"palette-button line-palette-item\" data-cmd=setLineWidth data-arg=3 _v-54ade979=\"\"> <div class=\"line-icon line-icon-3\" _v-54ade979=\"\"></div> </div> <div class=\"palette-button line-palette-item\" data-cmd=setLineWidth data-arg=5 _v-54ade979=\"\"> <div class=\"line-icon line-icon-5\" _v-54ade979=\"\"></div> </div> <div class=\"palette-button line-palette-item\" data-cmd=setLineWidth data-arg=7 _v-54ade979=\"\"> <div class=\"line-icon line-icon-7\" _v-54ade979=\"\"></div> </div> </div> ";

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"color-palette clearfix\" _v-5633701d=\"\"> <div class=\"palette-button color-palette-item\" data-cmd=setColor data-arg=\"{{ color }}\" v-for=\"(idx, color) in state.AVAILABLE_COLORS\" _v-5633701d=\"\"> <div class=color-fill v-bind:style=\"{ 'background-color': color }\" _v-5633701d=\"\"></div> </div> </div> ";

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"share-palette clearfix\" _v-7c4b9fd2=\"\"> <div class=\"palette-button share-palette-item\" data-cmd=share data-arg=facebook _v-7c4b9fd2=\"\"> <div class=\"share-icon share-icon-facebook\" _v-7c4b9fd2=\"\"></div> </div> <div class=\"palette-button share-palette-item\" data-cmd=share data-arg=twitter _v-7c4b9fd2=\"\"> <div class=\"share-icon share-icon-twitter\" _v-7c4b9fd2=\"\"></div> </div> </div> ";

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"paint-app pixelated\" _v-e4c3d5a2=\"\"> <div class=\"background overlay stretchy halftone\" style=\"z-index: -1\" _v-e4c3d5a2=\"\"></div> <win-header title=\"MS-DOS Executive\" _v-e4c3d5a2=\"\"></win-header> <dos-file-menu _v-e4c3d5a2=\"\"></dos-file-menu> <div class=file-window _v-e4c3d5a2=\"\"> <div class=drive-list _v-e4c3d5a2=\"\"> <div class=\"button drive-a\" _v-e4c3d5a2=\"\"><label _v-e4c3d5a2=\"\">A</label> <span class=drive-icon _v-e4c3d5a2=\"\"></span></div> <div class=\"button drive-b\" _v-e4c3d5a2=\"\"><label _v-e4c3d5a2=\"\">B</label> <span class=drive-icon _v-e4c3d5a2=\"\"></span></div> <div class=\"button drive-c selected\" _v-e4c3d5a2=\"\"><label _v-e4c3d5a2=\"\">C</label> <span class=drive-icon _v-e4c3d5a2=\"\"></span></div> <div class=cwd _v-e4c3d5a2=\"\"> C: \\WINDOWS </div> </div> <div class=file-list _v-e4c3d5a2=\"\"> <div class=col1 _v-e4c3d5a2=\"\"> <label _v-e4c3d5a2=\"\">ABC.TXT</label> <label _v-e4c3d5a2=\"\">CALC.EXE</label> <label _v-e4c3d5a2=\"\">CALENDAR.EXE</label> <label _v-e4c3d5a2=\"\">CARDFILE.EXE</label> <label _v-e4c3d5a2=\"\">CLIPBRD.EXE</label> <label _v-e4c3d5a2=\"\">CLOCK.EXE</label> <label _v-e4c3d5a2=\"\">CONTROL.EXE</label> <label _v-e4c3d5a2=\"\">COURA.FON</label> <label _v-e4c3d5a2=\"\">COURB.FON</label> <label _v-e4c3d5a2=\"\">DOTHIS.TXT</label> <label _v-e4c3d5a2=\"\">HELVA.FON</label> <label _v-e4c3d5a2=\"\">HELVB.FON</label> <label _v-e4c3d5a2=\"\">MODERN.FON</label> <label _v-e4c3d5a2=\"\">MSDOS.EXE</label> <label _v-e4c3d5a2=\"\">NOTEPAD.EXE</label> <label class=selected v-on:click=PAINT _v-e4c3d5a2=\"\">PAINT.EXE</label> <label _v-e4c3d5a2=\"\">PRACTICE.DOC</label> <label _v-e4c3d5a2=\"\">README.DOC</label> </div> <div class=col2 _v-e4c3d5a2=\"\"> <label _v-e4c3d5a2=\"\">REVERSI.EXE</label> <label _v-e4c3d5a2=\"\">ROMAN.FON</label> <label _v-e4c3d5a2=\"\">SCRIPT.FON</label> <label _v-e4c3d5a2=\"\">SPOOLER.EXE</label> <label _v-e4c3d5a2=\"\">TERMINAL.EXE</label> <label _v-e4c3d5a2=\"\">TMSRA.FON</label> <label _v-e4c3d5a2=\"\">WIN.COM</label> <label _v-e4c3d5a2=\"\">WIN.INI</label> <label _v-e4c3d5a2=\"\">WIN100.BIN</label> <label _v-e4c3d5a2=\"\">WIN100.OVL</label> <label _v-e4c3d5a2=\"\">WINOLDAP.GRB</label> <label _v-e4c3d5a2=\"\">WINOLDAP.MOD</label> <label _v-e4c3d5a2=\"\">WRITE.EXE</label> </div> <div class=\"column small-8\" _v-e4c3d5a2=\"\"></div> </div> </div> <bottom-bar _v-e4c3d5a2=\"\"></bottom-bar> </div> ";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"dialog clearfix\" _v-fcb00eac=\"\"> <div class=row _v-fcb00eac=\"\"> <div class=column _v-fcb00eac=\"\"> <label _v-fcb00eac=\"\">Open File:</label> <div class=fake-input _v-fcb00eac=\"\">{{ selectedFile }}</div> </div> </div> <div class=row _v-fcb00eac=\"\"> <div class=\"column small-6\" _v-fcb00eac=\"\"> <ul class=open-files _v-fcb00eac=\"\"> <li _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">[-A-]</label></li> <li _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">[-B-]</label></li> <li _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">[-C-]</label></li> <li _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">[..]</label></li> <li v-bind:class=\"{selected: selectedFile==NINJACAT}\" v-on:click=selectFile(NINJACAT) _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">{{ NINJACAT }}</label></li> <li v-bind:class=\"{selected: selectedFile==WALLPAPER}\" v-on:click=selectFile(WALLPAPER) _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">{{ WALLPAPER }}</label></li> </ul> </div> <div class=\"column small-6\" _v-fcb00eac=\"\"> <label class=current-loc _v-fcb00eac=\"\">C:\\windows</label> <div class=dialog-buttons _v-fcb00eac=\"\"> <a href=/static/images/ninjacat-wallpaper-2016.png target=_blank download=\"\" class=form-button v-if=\"selectedFile==WALLPAPER\" _v-fcb00eac=\"\"><div class=form-button-box _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">Download</label></div></a> <div class=form-button v-else=\"\" v-on:click=openFile _v-fcb00eac=\"\"><div class=form-button-box _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">Open</label></div></div> <div class=form-button data-cmd=closePalette _v-fcb00eac=\"\"><div class=form-button-box _v-fcb00eac=\"\"><label _v-fcb00eac=\"\">Cancel</label></div></div> </div> </div> </div> </div> ";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(127)
	__vue_script__ = __webpack_require__(67)
	__vue_template__ = __webpack_require__(181)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(117)
	__vue_script__ = __webpack_require__(68)
	__vue_template__ = __webpack_require__(170)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(126)
	__vue_script__ = __webpack_require__(69)
	__vue_template__ = __webpack_require__(171)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(118)
	__vue_script__ = __webpack_require__(70)
	__vue_template__ = __webpack_require__(172)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(133)
	__vue_script__ = __webpack_require__(72)
	__vue_template__ = __webpack_require__(187)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(120)
	__vue_script__ = __webpack_require__(73)
	__vue_template__ = __webpack_require__(174)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(121)
	__vue_script__ = __webpack_require__(74)
	__vue_template__ = __webpack_require__(175)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(122)
	__vue_script__ = __webpack_require__(75)
	__vue_template__ = __webpack_require__(176)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(123)
	__vue_script__ = __webpack_require__(77)
	__vue_template__ = __webpack_require__(178)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(129)
	__vue_script__ = __webpack_require__(78)
	__vue_template__ = __webpack_require__(183)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.3e22243e834ba578aaf6.js